<template>
    <div class="preset1">
        <div class="container">

            <landing-page-hero-box-default
                v-if="heroImage"
                :image="heroImage"
                :title="heroTitle"
                :entries="heroListEntries"
                :button-text="heroButtonText"
                :button-link="heroButtonLink"
                :target="heroButtonTarget"
                :color="heroTextColor"
                :display-type="heroImageDisplayType"
            ></landing-page-hero-box-default>   

            <landing-page-image-text-box-default
                v-if="leftImage"
                :image="leftImage"
                :title="leftTitle"
                :content="leftContent"
                :button-text="leftButtonText"
                :button-link="leftButtonUrl"
                :target="leftButtonTarget"
            ></landing-page-image-text-box-default>   
    
            <landing-page-image-text-box-default
                v-if="rightImage"
                :image="rightImage"
                :title="rightTitle"
                :content="rightContent"
                :button-text="rightButtonText"
                :button-link="rightButtonUrl"
                :target="rightButtonTarget"
                :reverse="true"
            ></landing-page-image-text-box-default>  

            <landing-page-gallery-default
                :leftImage="galleryLeftImage"
                :middleImage="galleryMiddleImage"
                :rightImage="galleryRightImage"
            ></landing-page-gallery-default>
        </div>
    </div>
</template>

<script>
import LandingPageImageTextBoxDefault from '../molecules/LandingPageImageTextBoxDefault.vue'
import LandingPageHeroBoxDefault from '../molecules/LandingPageHeroBoxDefault.vue'
import LandingPageGalleryDefault from '../molecules/LandingPageGalleryDefault.vue'

export default {
    name: 'PresetLandingPageDefault',
    components: {
        LandingPageImageTextBoxDefault,
        LandingPageHeroBoxDefault,
        LandingPageGalleryDefault
    },
    props: {
      content: {
        required: true,
        default: null
      }
    },
    data() {
        return {
            color: null
        }
    },
    mounted() {
        this.color = this.content.hero_color
    },
    computed: {
        heroImage() {
            if(this.$root.breakpoints.gt.lg) {
                return this.content ? this.content.hero_background : ''
            }
            else if(this.$root.breakpoints.gt.md) {
                return this.content ? this.content.hero_background_tablet : ''
            }
            else {
                return this.content ? this.content.hero_background_mobile : ''
            }
        },
        heroImageDisplayType() {
            if(this.content) {
                return parseInt(this.content.hero_background_image_display) === 1 ? 'cropped' : 'full'
            }
            return 'cropped'
        },
        heroTitle() {
            return this.content ? this.content.hero_title : ''
        },
        heroListEntries() {
            return this.content && this.content.hero_list !== null ? this.content.hero_list.split("\n") : []
        },
        heroButtonText() {
            return this.content ? this.content.hero_button_text : ''
        },
        heroButtonLink() {
            return this.content ? this.content.hero_button_link : ''
        },
        heroButtonTarget() {
            if(this.content) {
                return this.content.hero_button_link_external ? '_blank' : '_self'
            }
            return '_self'
        },
        heroTextColor() {
            return this.content ? this.content.hero_color : ''
        },
        leftImage() {
            return this.content ? this.content.left_image : ''
        },
        leftTitle() {
            return this.content ? this.content.left_image_title : ''
        },
        leftContent() {
            return this.content ? this.content.left_image_content : ''
        },
        leftButtonText() {
            return this.content ? this.content.left_image_button_text : ''
        },
        leftButtonUrl() {
            return this.content ? this.content.left_image_button_url : ''
        },
        leftButtonTarget() {
            if(this.content) {
                return this.content.left_image_link_external ? '_blank' : '_self'
            }
            return '_self'
        },
        rightImage() {
            return this.content ? this.content.right_image : ''
        },
        rightTitle() {
            return this.content ? this.content.right_image_title : ''
        },
        rightContent() {
            return this.content ? this.content.right_image_content : ''
        },
        rightButtonText() {
            return this.content ? this.content.right_image_button_text : ''
        },
        rightButtonUrl() {
            return this.content ? this.content.right_image_button_url : ''
        },
        rightButtonTarget() {
            if(this.content) {
                return this.content.right_image_link_external ? '_blank' : '_self'
            }
            return '_self'
        },
        galleryLeftImage() {
            return this.content ? this.content.gallery_left_image : ''
        },
        galleryMiddleImage() {
            return this.content ? this.content.gallery_middle_image : ''
        }
        ,
        galleryRightImage() {
            return this.content ? this.content.gallery_right_image : ''
        }
    }
}
</script>